import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { LeftPaddedContent } from '../../common/styledComponents';
import { TermostatstyringRadio } from '../../common/termostatstyringRadio';
import { useOppvarmingFormContext } from '../../../utils';
import { useCommonValidation } from '../../../hooks/useCommonValidation';

export const Fordelingssystem = () => {
  const { register, watch, formState } = useOppvarmingFormContext();
  const { t } = useTranslation();
  const { validateVarmefordeling } = useCommonValidation();

  const gulvvarmeSelected = watch(`bioenergi.value.kjel.value.gulvvarme.selected`);
  const radiatorSelected = watch(`bioenergi.value.kjel.value.radiator.selected`);

  const fordelingssystemErrors = formState.errors?.bioenergi?.value?.kjel?.value;

  // Radiator and gulvvarme is validated as a group and share the exact same validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = fordelingssystemErrors?.radiator?.selected;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('register.tekniskUtstyr.vannbarenVarme.fordeling.label')}</Fieldset.Legend>
      <Checkbox
        aria-invalid={!!fordelingssystemErrors?.gulvvarme?.selected?.message}
        label={t('register.tekniskUtstyr.vannbarenVarme')}
        {...register(`bioenergi.value.kjel.value.gulvvarme.selected`, {
          deps: ['bioenergi.value.kjel.value.radiator.selected'],
          validate: (_, formValues) => validateVarmefordeling(formValues.bioenergi?.value?.kjel?.value),
          shouldUnregister: true
        })}
      />
      {gulvvarmeSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="bioenergi.value.kjel.value.gulvvarme.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      <Checkbox
        aria-invalid={!!fordelingssystemErrors?.radiator?.selected?.message}
        label={t('register.tekniskUtstyr.radiator.label')}
        {...register(`bioenergi.value.kjel.value.radiator.selected`, {
          deps: ['bioenergi.value.kjel.value.gulvvarme.selected'],
          validate: (_, formValues) => validateVarmefordeling(formValues.bioenergi?.value?.kjel?.value),
          shouldUnregister: true
        })}
      />
      {radiatorSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="bioenergi.value.kjel.value.radiator.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      {fordelingssystemSelectionError && (
        <ValidationMessage>{fordelingssystemSelectionError.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
